import React from 'react';
import {
    IGameContextViewModel
} from "../../../../../../services/game-runner/interfaces/game-context/game-context-view-model.interface";
import {OrbitComponent} from "../../../../../base-components/orbit-component/orbit-component";
import {observer} from "mobx-react";
import {
    GameDetailHistoryHeaderBarGameRoundDateBox
} from "../../boxes/game-round-date/game-detail-history-header-bar-game-round-date.box";

export const GameDetailHistoryHeaderBarGameRoundDateComponent = observer(
    class GameDetailHistoryHeaderBarGameRoundDateComponent extends OrbitComponent<{gameContext: IGameContextViewModel}> {
        private _roundDateValue = () => {
            return this.services.regulation.current.timeFormatter.formatHistoryRecordDate(this.props.gameContext.historyGameParams.gameRoundDate);
        }

        render() {
            return (
                <GameDetailHistoryHeaderBarGameRoundDateBox>
                    {this._roundDateValue()}
                </GameDetailHistoryHeaderBarGameRoundDateBox>
            );
        }
    }
);